__turbopack_context__.v({
  "error-content": "error-page-content-base-module-scss-module__fUDqra__error-content",
  "error-content__actions": "error-page-content-base-module-scss-module__fUDqra__error-content__actions",
  "error-content__icon": "error-page-content-base-module-scss-module__fUDqra__error-content__icon",
  "error-content__message": "error-page-content-base-module-scss-module__fUDqra__error-content__message",
});
